module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cart-notification/cart-notification.component.scss
// module id = ./src/app/components/cart-notification/cart-notification.component.scss
// module chunks = main